"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

const SvgMapPin = props => {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M24 12c5.523 0 10 4.477 10 10 0 3.372-1.802 6.676-4.774 9.813a31.132 31.132 0 01-4.254 3.726c-.195.141-.337.24-.417.293a1 1 0 01-1.11 0c-.08-.054-.222-.152-.417-.293a31.132 31.132 0 01-4.254-3.726C15.802 28.676 14 25.372 14 22c0-5.523 4.477-10 10-10zm0 2a8 8 0 00-8 8c0 2.753 1.573 5.636 4.226 8.437A29.155 29.155 0 0024 33.773a29.155 29.155 0 003.774-3.335C30.427 27.635 32 24.752 32 22a8 8 0 00-8-8zm0 4a4 4 0 110 8 4 4 0 010-8zm0 2a2 2 0 100 4 2 2 0 000-4z",
    id: "map-pin_svg__a"
  }));
};

var _default = SvgMapPin;
exports.default = _default;